function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_213_7195)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M22.5 0H21.25C20.9185 0 20.6005 0.131696 20.3661 0.366117C20.1317 0.600537 20 0.918479 20 1.25V18.75C20 19.0815 20.1317 19.3995 20.3661 19.6339C20.6005 19.8683 20.9185 20 21.25 20H22.5C22.8315 20 23.1495 19.8683 23.3839 19.6339C23.6183 19.3995 23.75 19.0815 23.75 18.75V1.25C23.75 0.918479 23.6183 0.600537 23.3839 0.366117C23.1495 0.131696 22.8315 0 22.5 0V0ZM16.25 5H15C14.6685 5 14.3505 5.1317 14.1161 5.36612C13.8817 5.60054 13.75 5.91848 13.75 6.25V18.75C13.75 19.0815 13.8817 19.3995 14.1161 19.6339C14.3505 19.8683 14.6685 20 15 20H16.25C16.5815 20 16.8995 19.8683 17.1339 19.6339C17.3683 19.3995 17.5 19.0815 17.5 18.75V6.25C17.5 5.91848 17.3683 5.60054 17.1339 5.36612C16.8995 5.1317 16.5815 5 16.25 5ZM10 10H8.75C8.41848 10 8.10054 10.1317 7.86612 10.3661C7.6317 10.6005 7.5 10.9185 7.5 11.25V18.75C7.5 19.0815 7.6317 19.3995 7.86612 19.6339C8.10054 19.8683 8.41848 20 8.75 20H10C10.3315 20 10.6495 19.8683 10.8839 19.6339C11.1183 19.3995 11.25 19.0815 11.25 18.75V11.25C11.25 10.9185 11.1183 10.6005 10.8839 10.3661C10.6495 10.1317 10.3315 10 10 10Z",
  fill: "#BBBBBB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 16.25V18.75C5 19.0815 4.8683 19.3995 4.63388 19.6339C4.39946 19.8683 4.08152 20 3.75 20H2.5C2.16848 20 1.85054 19.8683 1.61612 19.6339C1.3817 19.3995 1.25 19.0815 1.25 18.75V16.25C1.25 15.9185 1.3817 15.6005 1.61612 15.3661C1.85054 15.1317 2.16848 15 2.5 15H3.75C4.08152 15 4.39946 15.1317 4.63388 15.3661C4.8683 15.6005 5 15.9185 5 16.25Z",
  fill: "#434343"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_213_7195"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 20,
  fill: "white"
})));

function SvgLowSignal(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowSignal);
export default __webpack_public_path__ + "static/media/low-signal.975afa96.svg";
export { ForwardRef as ReactComponent };